// extracted by mini-css-extract-plugin
export default {"buttons":"CreateContractModal_buttons__UXisO"};